export default __webpack_public_path__ + "static/media/workshopImg3.fd6af81b.jpg";